module.exports = __webpack_public_path__ + "img/edit-03.45f947b7.svg";